import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

const Team = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="equipo"
      data-testid="team-section"
      ref={ref}
      className="py-20 md:py-32 bg-cream-alt relative overflow-hidden"
    >
      {/* Background Decoration */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-terracotta/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-gold/10 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <span className="text-terracotta font-medium uppercase tracking-widest text-sm">
            Familia Salkantay
          </span>
          <h2
            className="font-heading text-4xl md:text-5xl font-bold text-coffee mt-4 mb-6"
            data-testid="team-title"
          >
            Nuestra Fundadora
          </h2>
          <p className="text-coffee-light text-lg max-w-2xl mx-auto">
            Detrás de cada plato hay una historia de amor por el Perú.
          </p>
        </motion.div>

        {/* Founder Story */}
        <div className="grid md:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Photo */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative group"
          >
            <img
              src="/team/founder-marisol.jpg"
              alt="Marisol Chacón Zevallos, fundadora de SALKANTAY"
              className="rounded-2xl shadow-2xl w-full h-[380px] sm:h-[450px] md:h-[500px] lg:h-[560px] object-cover object-top group-hover:shadow-3xl transition-shadow duration-300"
              data-testid="founder-image"
            />
            <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur-sm rounded-xl px-4 py-2 shadow-lg">
              <p className="font-accent text-terracotta text-lg">Marisol Chacón Zevallos · Fundadora</p>
            </div>
          </motion.div>

          {/* Story */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <span className="text-6xl font-heading text-terracotta/20 leading-none block mb-2">
              "
            </span>
            <p className="text-coffee text-lg md:text-xl leading-relaxed -mt-6">
              Todo empezó con el sueño de{' '}
              <strong className="text-terracotta">Marisol Chacón Zevallos</strong> de traer a
              Madrid un pedacito de su tierra: la frescura de la cocina <strong>Marina</strong>,
              la calidez de los platos <strong>Criollos</strong>, el toque asiático del{' '}
              <strong>Chifa</strong> y el humo inconfundible del <strong>Pollo a la Brasa</strong>.
            </p>
            <p className="text-coffee-light text-base md:text-lg leading-relaxed mt-4">
              Años después, sigue al frente del restaurante cada jornada, muchas veces detrás de
              la barra o entre las mesas, con la misma ilusión del primer día por la que un día se
              embarcó en esta aventura.
            </p>
            <p className="font-accent text-terracotta text-xl mt-6">
              — Marisol Chacón Zevallos, Fundadora de Salkantay
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Team;
